// import { useEffect, useMemo, useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { Eye, X } from 'lucide-react';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';
// import SalarySlip from '../../../components/PayRoll/SalarySlip';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
// import { buildSalarySlipBreakdown } from '../../../utils/salarySlip';
// import { getPayrollDetailsBySno } from '../../../action/Payroll';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;

// const PayrollHeader = () => {
//   const dispatch = useDispatch();

//   const { list: periods } = usePayrollEntity('payrollPeriods');
//   const { list: employeeSalaries, loading: salariesLoading } = usePayrollEntity('employeeSalary');

//   const [selectedPeriodId, setSelectedPeriodId] = useState('');
//   const [viewing, setViewing] = useState(null); // header row currently shown in the dialog
//   const [payrollDetails, setPayrollDetails] = useState(null);
//   const [detailsLoading, setDetailsLoading] = useState(false);
//   const [detailsError, setDetailsError] = useState('');
//   const [refreshing, setRefreshing] = useState(false);

//   // useEffect(() => {
//   //   if (!selectedPeriodId && periods.length > 0) {
//   //     setSelectedPeriodId(String(periods[0].id));
//   //   }
//   // }, [periods, selectedPeriodId]);

//   const filteredSalaries = useMemo(() => {
//     if (!selectedPeriodId) {
//       return [];
//     }

//     return employeeSalaries.filter(
//       (salary) =>
//         // String(salary.payrollPeriodId) === String(selectedPeriodId) &&
//         salary.isActive &&
//         salary.isCurrent
//     );
//   }, [employeeSalaries, selectedPeriodId]);

//   const rows = useMemo(() => {
//     return filteredSalaries.map((salary) => ({
//       id: salary.id,
//       employeeId: salary.employeeId,
//       empNo: salary.empNo || '-',
//       name: salary.name || `Employee #${salary.employeeId}`,
//       payrollPeriodId: salary.payrollPeriodId,
//       salaryReference: salary.salaryReference,
//       basicSalary: salary.basic,
//       grossSalary: salary.grossSalary,
//       workingDays: salary.workingDays,
//       dailyRate: salary.dailyRate,
//       status: salary.status,
//     }));
//   }, [filteredSalaries]);

//   const selectedPeriod = useMemo(() => {
//     return periods.find((period) => String(period.id) === String(selectedPeriodId));
//   }, [periods, selectedPeriodId]);

//   const handleViewSalarySlip = async (row, periodId) => {
//     setViewing(row);
//     setPayrollDetails(null);
//     setDetailsError('');
//     setDetailsLoading(true);
//     try {
//       const result = await dispatch(getPayrollDetailsBySno(selectedPeriodId, row.empNo));
//       setPayrollDetails(result);
//     } catch (error) {
//       console.error('Failed to load payroll details:', error);
//       setDetailsError(error?.message || 'Unable to load the salary slip.');
//     } finally {
//       setDetailsLoading(false);
//     }
//   };

//   const handleCloseSlip = () => {
//     setViewing(null);
//     setPayrollDetails(null);
//     setDetailsError('');
//     setDetailsLoading(false);
//   };

//   const breakdown = useMemo(() => {
//     if (!payrollDetails) {
//       return null;
//     }
//     return buildSalarySlipBreakdown(payrollDetails);
//   }, [payrollDetails]);

//   const viewingEmployee = useMemo(() => {
//     if (!viewing) {
//       return null;
//     }
//     return {
//       name: viewing.name,
//       empNo: viewing.empNo,
//     };
//   }, [viewing]);

//   const viewingPeriod = useMemo(() => {
//     if (payrollDetails) {
//       return (
//         periods.find(
//           (period) => String(period.id) === String(payrollDetails.HPH_PAYROLL_PERIOD_ID)
//         ) || selectedPeriod
//       );
//     }

//     return selectedPeriod;
//   }, [payrollDetails, periods, selectedPeriod]);

//   // Normalize HPH_* backend response into the shape expected by SalarySlip
//   const salarySlipHeader = useMemo(() => {
//     if (!payrollDetails) {
//       return null;
//     }
//     return {
//       payrollNo: payrollDetails.HPH_PAYROLL_NO,
//       payrollPeriodId: payrollDetails.HPH_PAYROLL_PERIOD_ID,
//       employeeId: payrollDetails.HPH_EMPLOYEE_ID,
//       employeeSalaryId: payrollDetails.HPH_EMPLOYEE_SALARY_ID,
//       payDate: payrollDetails.HPH_PAY_DATE
//         ? String(payrollDetails.HPH_PAY_DATE).split(' ')[0]
//         : '',
//       grossEarnings: Number(payrollDetails.HPH_GROSS_EARNINGS || 0),
//       totalEarnings: Number(payrollDetails.HPH_TOTAL_EARNINGS || 0),
//       totalDeductions: Number(payrollDetails.HPH_TOTAL_DEDUCTIONS || 0),
//       employeeEpf: Number(payrollDetails.HPH_EMPLOYEE_EPF || 0),
//       employerEpf: Number(payrollDetails.HPH_EMPLOYER_EPF || 0),
//       employerEtf: Number(payrollDetails.HPH_EMPLOYER_ETF || 0),
//       paye: Number(payrollDetails.HPH_PAYE || 0),
//       netSalary: Number(payrollDetails.HPH_NET_SALARY || 0),
//       workingDays: Number(payrollDetails.HPH_WORKING_DAYS || 0),
//       presentDays: Number(payrollDetails.HPH_PRESENT_DAYS || 0),
//       noPayDays: Number(payrollDetails.HPH_NO_PAY_DAYS || 0),
//       otHours: Number(payrollDetails.HPH_OT_HOURS || 0),
//       status: payrollDetails.HPH_STATUS,
//       remarks: payrollDetails.HPH_REMARKS,
//     };
//   }, [payrollDetails]);

//   // Fake refresh
//   const refreshTable = () => {
//     setRefreshing(true);

//     setTimeout(() => {
//       setRefreshing(false)
//     }, 500);
//   };

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={['Payroll', 'Payroll Header']}
//         title="Payroll Header"
//         subtitle="Payment details per employee and payroll period. View an employee's salary slip, print it, or download it as a PDF."
//       />

//       <Table
//         title="Payroll Header"
//         loading={salariesLoading || refreshing}
//         loadingMessage="Refreshing payroll records..."
//         rows={rows}
//         rowKey="id"
//         search
//         searchLabel="Search"
//         searchKeys={['empNo', 'name', 'salaryReference']}
//         searchPlaceholder="Search by employee name, number or salary reference..."
//         emptyMessage={
//           selectedPeriodId
//             ? 'No payroll records for this period.'
//             : 'Select a payroll period to view records.'
//         }
//         pageSize={8}
//         scrollClassName=""
//         toolbarExtra={
//           <div className="w-[260px] max-w-full">
//             <span className={LABEL}>Period ID</span>
//             <select
//               value={selectedPeriodId}
//               onChange={(event) => {
//                 setSelectedPeriodId(event.target.value);
//                 handleCloseSlip();
//                 refreshTable();
//               }}
//               className={`${FIELD} w-full`}
//             >
//               <option value="">-- Select Period --</option>
//               {periods
//                 .filter((period) => period.status === "Inactive")
//                 .map((period) => (
//                   <option key={period.id} value={String(period.id)}>
//                     {period.name}
//                   </option>
//                 ))
//               }
//             </select>
//           </div>
//         }
//         columns={[
//           {
//             key: 'name',
//             label: 'Employee',
//             grow: true,
//             className: 'font-semibold text-gray-900',
//             render: (row) => `${row.name} (${row.empNo})`,
//           },
//           { key: 'salaryReference', label: 'Salary Reference', className: 'text-gray-600' },
//           {
//             key: 'basicSalary',
//             label: 'Basic Salary (Rs)',
//             align: 'right',
//             className: 'text-gray-700',
//             render: (row) => fmtMoney(row.basicSalary),
//           },
//           {
//             key: 'grossSalary',
//             label: 'Gross Salary (Rs)',
//             align: 'right',
//             className: 'font-semibold text-gray-900',
//             render: (row) => fmtMoney(row.grossSalary),
//           },
//           {
//             key: 'status',
//             label: 'Status',
//             align: 'center',
//             render: (row) => <StatusPill label={row.status} />,
//           },
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             sortable: false,
//             render: (row) => (
//               <button
//                 type="button"
//                 onClick={() => handleViewSalarySlip(row)}
//                 className="inline-flex items-center gap-1.5 h-7 px-2 rounded-md text-[12px] font-semibold
//                   text-primary-700 hover:bg-primary-50 transition-colors"
//               >
//                 <Eye size={14} />
//                 View Salary Slip
//               </button>
//             ),
//           },
//         ]}
//       />

//       {/* ── Salary slip ──────────────────────────────────────────────
//           SalarySlip prints itself through a stylesheet that hides
//           everything except #salary-slip-print, and hides anything marked
//           .salary-slip-actions — so the close button keeps that class. */}
//       {viewing && (
//         <div
//           className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 px-4 py-8"
//           onClick={handleCloseSlip}
//         >
//           <div
//             className="relative w-full max-w-2xl rounded-xl bg-[#F7F7F7] shadow-lg"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               onClick={handleCloseSlip}
//               aria-label="Close"
//               className="salary-slip-actions absolute right-3 top-3 z-10 inline-flex h-8 w-8 items-center
//                 justify-center rounded-md text-gray-500 hover:bg-gray-200 hover:text-gray-700 transition-colors"
//             >
//               <X size={18} />
//             </button>

//             <div className="px-4 pb-4 pt-12">
//               {detailsLoading && (
//                 <div className="py-20 text-center text-sm text-gray-400">Loading salary slip...</div>
//               )}

//               {!detailsLoading && detailsError && (
//                 <div className="py-16 text-center text-sm text-red-700">{detailsError}</div>
//               )}

//               {!detailsLoading && !detailsError && payrollDetails && breakdown && salarySlipHeader && (
//                 <SalarySlip
//                   employee={viewingEmployee}
//                   period={viewingPeriod}
//                   header={salarySlipHeader}
//                   breakdown={breakdown}
//                 />
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PayrollHeader;


import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Eye, RotateCw, X } from 'lucide-react';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';
import SalarySlip from '../../../components/PayRoll/SalarySlip';

import usePayrollEntity from '../../../utils/usePayrollEntity';
import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
import { buildSalarySlipBreakdown } from '../../../utils/salarySlip';
import { fetchPayrollEntityList, fetchPayrollHeadersByPeriod, getPayrollDetailsBySno, reversePayroll, selectPayrollHeaders } from '../../../store/slices/payrollSlice';
import { useConfirm } from '../../../utils/ConfirmContext';
import useToast from '../../../utils/useToast';
import Toast from '../../../components/Toast/Toast';

const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
const LABEL = TABLE_THEME.fieldLabel;

const PayrollHeader = () => {
  const dispatch = useDispatch();

  const { list: periods } = usePayrollEntity('payrollPeriods');
  const { list: employeeSalaries, loading: salariesLoading } = usePayrollEntity('employeeSalary');

  const { data: periodHeaders, loading: headersLoading } = useSelector(selectPayrollHeaders) || { data: [], loading: false }

  const [selectedPeriodId, setSelectedPeriodId] = useState('');
  const [viewing, setViewing] = useState(null); // header row currently shown in the dialog
  const [payrollDetails, setPayrollDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [detailsError, setDetailsError] = useState('');
  const [refreshing, setRefreshing] = useState(false);
  const [reversing, setReversing] = useState(false);

  const confirm = useConfirm();
  const { toast, showToast, hideToast } = useToast();

  // Fetch the headers whenever the selected period changes
  useEffect(() => {
    if (selectedPeriodId) {
      dispatch(fetchPayrollHeadersByPeriod(selectedPeriodId));
    }
  }, [selectedPeriodId, dispatch]);

  // useEffect(() => {
  //   if (!selectedPeriodId && periods.length > 0) {
  //     setSelectedPeriodId(String(periods[0].id));
  //   }
  // }, [periods, selectedPeriodId]);

  const filteredSalaries = useMemo(() => {
    if (!selectedPeriodId) {
      return [];
    }

    return employeeSalaries.filter(
      (salary) =>
        // String(salary.payrollPeriodId) === String(selectedPeriodId) &&
        salary.isActive &&
        salary.isCurrent
    );
  }, [employeeSalaries, selectedPeriodId]);

  const rows = useMemo(() => {
    if (!selectedPeriodId || !periodHeaders) {
      return []
    }

    return periodHeaders.map((header) => {
      // Payroll Header stores the exact salary record used during calculation
      const salaryInfo = employeeSalaries.find(
        (salary) => String(salary.id) === String(header.HPH_EMPLOYEE_SALARY_ID)
      )

      // Find the master employee details using HPH_EMPLOYEE_ID
      const empInfo = employeeSalaries.find(
        (emp) => String(emp.employeeId) === String(header.HPH_EMPLOYEE_ID)
      );

      return {
        id: header.HPH_PAYROLL_ID,
        employeeId: header.HPH_EMPLOYEE_ID,
        employeeSalaryId: header.HPH_EMPLOYEE_SALARY_ID,

        empNo: empInfo?.empNo || '-',
        name: empInfo?.name || `Employee #${header.HPH_EMPLOYEE_ID}`,

        payrollPeriodId: header.HPH_PAYROLL_PERIOD_ID,

        salaryReference: salaryInfo?.salaryReference || '-',
        basicSalary: Number(salaryInfo?.basic || 0),
        dailyRate: Number(salaryInfo?.dailyRate || 0),

        grossSalary: Number(header.HPH_GROSS_EARNINGS || 0),
        workingDays: Number(header.HPH_WORKING_DAYS || 0),
        // dailyRate: empInfo?.dailyRate || 0,
        status: header.HPH_STATUS === 'C' ? 'Current' : header.HPH_STATUS,
      }
    })
  }, [periodHeaders, employeeSalaries, selectedPeriodId])

  const selectedPeriod = useMemo(() => {
    return periods.find((period) => String(period.id) === String(selectedPeriodId));
  }, [periods, selectedPeriodId]);

  const handleViewSalarySlip = async (row, periodId) => {
    setViewing(row);
    setPayrollDetails(null);
    setDetailsError('');
    setDetailsLoading(true);
    try {
      const result = await dispatch(getPayrollDetailsBySno(selectedPeriodId, row.empNo));
      setPayrollDetails(result);
    } catch (error) {
      console.error('Failed to load payroll details:', error);
      setDetailsError(error?.message || 'Unable to load the salary slip.');
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleCloseSlip = () => {
    setViewing(null);
    setPayrollDetails(null);
    setDetailsError('');
    setDetailsLoading(false);
  };

  const breakdown = useMemo(() => {
    if (!payrollDetails) {
      return null;
    }
    return buildSalarySlipBreakdown(payrollDetails);
  }, [payrollDetails]);

  const viewingEmployee = useMemo(() => {
    if (!viewing) {
      return null;
    }
    return {
      name: viewing.name,
      empNo: viewing.empNo,
    };
  }, [viewing]);

  const viewingPeriod = useMemo(() => {
    if (payrollDetails) {
      return (
        periods.find(
          (period) => String(period.id) === String(payrollDetails.HPH_PAYROLL_PERIOD_ID)
        ) || selectedPeriod
      );
    }

    return selectedPeriod;
  }, [payrollDetails, periods, selectedPeriod]);

  // Normalize HPH_* backend response into the shape expected by SalarySlip
  const salarySlipHeader = useMemo(() => {
    if (!payrollDetails) {
      return null;
    }
    return {
      payrollNo: payrollDetails.HPH_PAYROLL_NO,
      payrollPeriodId: payrollDetails.HPH_PAYROLL_PERIOD_ID,
      employeeId: payrollDetails.HPH_EMPLOYEE_ID,
      employeeSalaryId: payrollDetails.HPH_EMPLOYEE_SALARY_ID,
      payDate: payrollDetails.HPH_PAY_DATE
        ? String(payrollDetails.HPH_PAY_DATE).split(' ')[0]
        : '',
      grossEarnings: Number(payrollDetails.HPH_GROSS_EARNINGS || 0),
      totalEarnings: Number(payrollDetails.HPH_TOTAL_EARNINGS || 0),
      totalDeductions: Number(payrollDetails.HPH_TOTAL_DEDUCTIONS || 0),
      employeeEpf: Number(payrollDetails.HPH_EMPLOYEE_EPF || 0),
      employerEpf: Number(payrollDetails.HPH_EMPLOYER_EPF || 0),
      employerEtf: Number(payrollDetails.HPH_EMPLOYER_ETF || 0),
      paye: Number(payrollDetails.HPH_PAYE || 0),
      netSalary: Number(payrollDetails.HPH_NET_SALARY || 0),
      workingDays: Number(payrollDetails.HPH_WORKING_DAYS || 0),
      presentDays: Number(payrollDetails.HPH_PRESENT_DAYS || 0),
      noPayDays: Number(payrollDetails.HPH_NO_PAY_DAYS || 0),
      otHours: Number(payrollDetails.HPH_OT_HOURS || 0),
      status: payrollDetails.HPH_STATUS,
      remarks: payrollDetails.HPH_REMARKS,
    };
  }, [payrollDetails]);

  // Fake refresh
  const refreshTable = () => {
    setRefreshing(true);

    setTimeout(() => {
      setRefreshing(false)
    }, 500);
  };

  const handleReversePayroll = async () => {
    if (!selectedPeriodId) return;

    const periodName = selectedPeriod?.name || `Period #${selectedPeriodId}`;

    const confirmed = await confirm({
      title: 'Reverse Payroll?',
      message: `Are you sure you want to reverse the payroll calculation for ${periodName}? This will permanently delete the calculated records for this period.`,
      confirmLabel: 'Reverse Payroll',
      cancelLabel: 'Cancel',
      variant: 'danger',
    });

    if (!confirmed) return;

    try {
      setReversing(true);
      await dispatch(reversePayroll(selectedPeriodId));
      showToast('Payroll reversed successfully.', 'success');

      // Refresh period list
      dispatch(fetchPayrollEntityList('payrollPeriods'));

      // Refresh headers
      dispatch(fetchPayrollHeadersByPeriod(selectedPeriodId));
    } catch (error) {
      showToast(error?.message || 'Failed to reverse paroll.', 'error');
    } finally {
      setReversing(false);
    }
  }

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={['Payroll', 'Payroll Header']}
        title="Payroll Header"
        subtitle="Payment details per employee and payroll period. View an employee's salary slip, print it, or download it as a PDF."
      />

      <Table
        title="Payroll Header"
        loading={salariesLoading || headersLoading}
        loadingMessage="Loading payroll records..."
        rows={rows}
        rowKey="id"
        search
        searchLabel="Search"
        searchKeys={['empNo', 'name', 'salaryReference']}
        searchPlaceholder="Search by employee name, number or salary reference..."
        emptyMessage={
          selectedPeriodId
            ? 'No payroll records for this period.'
            : 'Select a payroll period to view records.'
        }
        pageSize={8}
        scrollClassName=""
        toolbarExtra={
          <div className="w-[260px] max-w-full">
            <span className={LABEL}>Period ID</span>
            <select
              value={selectedPeriodId}
              onChange={(event) => {
                setSelectedPeriodId(event.target.value);
                handleCloseSlip();
                // refreshTable();
              }}
              className={`${FIELD} w-full`}
            >
              <option value="">-- Select Period --</option>
              {periods
                .filter((period) => period.status === "Inactive")
                .map((period) => (
                  <option key={period.id} value={String(period.id)}>
                    {period.name}
                  </option>
                ))
              }
            </select>
          </div>
        }
        columns={[
          {
            key: 'name',
            label: 'Employee',
            grow: true,
            className: 'font-semibold text-gray-900',
            render: (row) => `${row.name} (${row.empNo})`,
          },
          { key: 'salaryReference', label: 'Salary Reference', className: 'text-gray-600' },
          {
            key: 'basicSalary',
            label: 'Basic Salary (Rs)',
            align: 'right',
            className: 'text-gray-700',
            render: (row) => fmtMoney(row.basicSalary),
          },
          {
            key: 'grossSalary',
            label: 'Gross Salary (Rs)',
            align: 'right',
            className: 'font-semibold text-gray-900',
            render: (row) => fmtMoney(row.grossSalary),
          },
          {
            key: 'status',
            label: 'Status',
            align: 'center',
            render: (row) => <StatusPill label={row.status} />,
          },
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            sortable: false,
            render: (row) => (
              <button
                type="button"
                onClick={() => handleViewSalarySlip(row)}
                className="inline-flex items-center gap-1.5 h-7 px-2 rounded-md text-[12px] font-semibold
                  text-primary-700 hover:bg-primary-50 transition-colors"
              >
                <Eye size={14} />
                View Salary Slip
              </button>
            ),
          },
        ]}
      />

      {selectedPeriodId && rows.length > 0 && (
        <div className="flex justify-end pt-2">
          <button
            type="button"
            disabled={reversing}
            onClick={handleReversePayroll}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold
              text-white bg-red-600 hover:bg-red-700 active:bg-red-800 disabled:opacity-50 
              disabled:cursor-not-allowed shadow-sm transition-colors"
          >
            <RotateCw size={16} className={reversing ? 'animate-spin' : ''} />
            {reversing ? 'Reversing Payroll...' : 'Reverse Payroll'}
          </button>
        </div>
      )}

      {viewing && (
        <div
          className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 px-4 py-8"
          onClick={handleCloseSlip}
        >
          <div
            className="relative w-full max-w-2xl rounded-xl bg-[#F7F7F7] shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseSlip}
              aria-label="Close"
              className="salary-slip-actions absolute right-3 top-3 z-10 inline-flex h-8 w-8 items-center
                justify-center rounded-md text-gray-500 hover:bg-gray-200 hover:text-gray-700 transition-colors"
            >
              <X size={18} />
            </button>

            <div className="px-4 pb-4 pt-12">
              {detailsLoading && (
                <div className="py-20 text-center text-sm text-gray-400">Loading salary slip...</div>
              )}

              {!detailsLoading && detailsError && (
                <div className="py-16 text-center text-sm text-red-700">{detailsError}</div>
              )}

              {!detailsLoading && !detailsError && payrollDetails && breakdown && salarySlipHeader && (
                <SalarySlip
                  employee={viewingEmployee}
                  period={viewingPeriod}
                  header={salarySlipHeader}
                  breakdown={breakdown}
                />
              )}
            </div>
          </div>
        </div>
      )}

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </div>
  );
};

export default PayrollHeader;